<script setup lang="ts">
import type {
  Size,
  Variant,
} from '~theme/components/atoms/styles/ButtonFlatStyle.vue';
import ButtonFlatStyle from '~theme/components/atoms/styles/ButtonFlatStyle.vue';

export type { Size, Variant };

const props = defineProps<{
  href: HTMLAnchorElement['href'];
  size?: Size;
  variant?: Variant;
  disabled?: boolean;
}>();

defineOptions({
  inheritAttrs: false,
});

const tag = computed(() => (props.disabled ? 'span' : 'a'));
</script>

<template>
  <ButtonFlatStyle :disabled="disabled" :size="size" :variant="variant">
    <component :is="tag" :href="href" v-bind="$attrs">
      <slot />
    </component>
  </ButtonFlatStyle>
</template>
